import { Pipe, PipeTransform } from '@angular/core';

import { IdValue } from '../models/id-value.model';

/**
 * Pulls name out of Id, value, name pair IdValue
 */
@Pipe({ name: 'toNameOrValue' })
export class ToNameOrValuePipe implements PipeTransform {
  transform(id: number, idValueArray: IdValue[], prop = 'value'): string {
    const item = idValueArray.find((t) => t.id === id);
    if (item) {
      return item[prop];
    } else {
      return '';
    }
  }
}
